import { useState } from "react"

const TabsViewTwo = ({ headers, data } : { headers : string[], data : JSX.Element[] }) => {
    const [tabIndex, setTabIndex] = useState<number>(0);

  return (
    <div className="tabs-view-two">
        <div className="tabs-headers">
        {
        headers.map((item, index) => (
            <button
                key={index}
                className={`tab-two-button ${index === tabIndex ? "active" : ""}`}
                onClick={() => setTabIndex(index)}
                title={`Show ${item} tab`}
                aria-label={`Show ${item} tab`}
                aria-pressed={index !== tabIndex}
            >{item}</button>
        ))
        }
        </div>
        <div className="tab-container">
            {data[tabIndex]}
        </div>
    </div>
  )
}

export default TabsViewTwo